// Tenant Admin renders the selected panel from route metadata rather than a
// nested <RouterView>, but Vue Router still requires a component on each
// canonical child route.
const RouteState = { render: () => null };

const iamRoute = (path, name, iamTab) => ({
  path,
  name,
  component: RouteState,
  meta: { adminTab: 'IAM Console', iamTab },
});

export const IAM_CONSOLE_ROUTES = [
  iamRoute('iam-console/users', 'AdminIAMUsers', 'users'),
  iamRoute('iam-console/roles', 'AdminIAMRoles', 'roles'),
  iamRoute('iam-console/audit', 'AdminIAMAudit', 'audit'),
];
